<template>
	<div class="content">
		<hheader1 :pathname="pathname" @showMobile="showMobile"></hheader1>

		<swiper v-if="list.length > 0" class="swiper-container"
		    :style="{height:screenW>880?screenH:'auto'}, {width:+ '100%;'}" @swiper="onSwiper" @slideChange="onSlideChange"
			:modules="modules" :pagination="{ clickable: true }" :autoplay="{
		      disableOnInteraction: false,
		      delay: 4000,
		      }" :direction='horizontal' :navigation="false" :loop="true">
			<swiper-slide class="banner" style="width: 100%; height: 100%;" v-for="(item, index) in list" :key="index">
				<img :src="item.carouselUrl" style="object-fit: fit;"/>
				<div class="banner-sec">
					<div>企业使命：科技赋能, 点亮绿色未来</div>
				</div>
			</swiper-slide>
			<div class="pagination">
				<div v-for="(item, index) in list.length" :key="index" :class="cIndex == index?'sdiv':''"></div>
			</div>
		</swiper>


		<!-- 公司详情 -->
		<div class="gs">
			<div class="gs-cc">
				<div class="gs-c-l">
					<img src="../assets/newimg/202.jpg" alt="">
					<div class="gs-c-l-f">
						<div class="item">
							<div class="item-h">{{num1}} <span>万元</span> </div>
							<div class="item-f">注册资本</div>
						</div>
						<div class="item">
							<div class="item-h">贰级</div>
							<div class="item-f">电力总包</div>
						</div>
						<div class="item">
							<div class="item-h">肆级</div>
							<div class="item-f">承装修试</div>
						</div>
						<div class="item">
							<div class="item-h">{{num2}} <span>W</span></div>
							<div class="item-f">累计装机容量</div>
						</div>
					</div>
				</div>
				<div class="gs-c-r">
					<div class="title">
						浙江中概电力科技有限公司
					</div>
					<div class="sec sec-zh" style="letter-spacing: 2px;">
						创建于2015年，系为深耕风力与光伏发电、 储能等新能源领域的高新技术企业。公司集技术研发、项目开发与投资、系统设计与集成、建设与运维等业务于一体，专注于光伏、储能、分散式风电、电力及运维五大核心板块的投资与建设。
					</div>
					<div class="sec sec-zh" style="letter-spacing: 2px;">
						公司具有电力工程总承包二级、承装承修承试三级等专业资质，聚集了一大批具有丰富经验的风电、光伏和电力行业的研发与设计、项目管理、供应链、安装调试、电站运维等领域优秀人才，拥有先进的设计理念、丰富的运作经验、成熟的管理团队，系国内最早从事分布式风电、光伏发电和储能业务的新能源开发与建设企业之一。
					</div>
					<div class="more" style="cursor: pointer;">
						<div id="morebtn" @click="goabout(0)">查看更多</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 业务与服务 -->
		<div class="fw">
			<div class="fw-cc">
				<div class="fw-h">业务与服务</div>
				<div class="fw-b">
					<img src="../assets/home/编组 20 (1).png" alt="">
					<!-- <div class="fw-b-sec">公司在全球范围寻求合作伙伴，投资开发优质的光伏（重点关注工商业分布式和地面集中式电站）、风电、储能和电力项目。</div>
                    <div class="fw-b-sec1">公司在全球范围寻求合作伙伴，投资开发优质的光伏（重点关注工商业分布式和地面集中式电站）、风电、储能和电力项目。</div>
                    <div class="fw-b-sec2">公司在全球范围寻求合作伙伴，投资开发优质的光伏（重点关注工商业分布式和地面集中式电站）、风电、储能和电力项目。</div>
                    -->
				</div>
				<div class="fw-more" style="margin-top: 70px;cursor: pointer;">
					<div id="morebtn111" @click="goservice">查看更多</div>
				</div>
			</div>
		</div>

		<!-- 新闻媒体 -->
		<div class="mt">
			<div class="mt-cc">
				<div class="mt-h">新闻媒体</div>
				<div class="mt-b">
					<div class="item" style="cursor: pointer;" v-for="(item, index) in xwlist.slice(0,3)" :key="index"
						@click="tapMediumDetails(item)">
						<img :src="item.barticleUrl" alt="">
						<div class="item-t">
							{{item.barticleTile}}
						</div>
						<div class="item-s">
							{{item.createTime.split('00:00:00')[0]}}
						</div>
					</div>
				</div>
				<div class="mt-more" style="margin-top: 70px;cursor: pointer;">
					<div id="morebtn" @click="goMedium">查看更多</div>
				</div>
			</div>
		</div>

		<!-- 合作伙伴 -->
		<div class="hb">
			<div class="hb-cc">
				<div class="hb-h">合作伙伴</div>
				<div class="hb-b">
					
					<img class="item-h" src="../assets/hezuo/11@2x.png" alt="">
					<img class="item-h" src="../assets/hezuo/12@2x.png" alt="">
					<img class="item-h" src="../assets/hezuo/13@2x.png" alt="">
					<img class="item-h" src="../assets/hezuo/14@2x.png" alt="">
					<img class="item-h" src="../assets/hezuo/15@2x.png" alt="">
					<img class="item-h" src="../assets/hezuo/16@2x.png" alt="">
					<img class="item-h" src="../assets/hezuo/21@2x.png" alt="">
					
					<img class="item-h" src="../assets/hezuo/22@2x.png" alt="">
					<img class="item-h" src="../assets/hezuo/23@2x.png" alt="">
					<img class="item-h" src="../assets/hezuo/24@2x.png" alt="">
					<img class="item-h" src="../assets/hezuo/25@2x.png" alt="">
					<img class="item-h" src="../assets/hezuo/26@2x.png" alt="">
					<img class="item-h" src="../assets/hezuo/31@2x.png" alt="">
					<img class="item-h" src="../assets/hezuo/32@2x.png" alt="">
					
					<img class="item-h" src="../assets/hezuo/33@2x.png" alt="">
					<img class="item-h" src="../assets/hezuo/34@2x.png" alt="">
					<img class="item-h" src="../assets/hezuo/35@2x.png" alt="">
					<img class="item-h" src="../assets/hezuo/36@2x.png" alt="">
  
				</div>
				<div class="hb-more" style="margin-top: 70px;cursor: pointer;">
					<div id="morebtn11" @click="gocase">查看更多</div>
				</div>
			</div>
		</div>
		
		

		<!-- 资质荣誉 -->
		<div class="ry">
			<div class="ry-cc">
				<div class="ry-h">资质荣誉</div>
				<div class="ry-b">
					<img class="ry-b-l" @click="next" style="cursor: pointer;" src="../../public/imgs/home/编组 6@2x.png" alt="">
					<div class="ry-b-c">
						<div class="item" @click="handlePreview(item.barticleUrl)" v-for="(item, index) in currentImages" :key="index">
							<img class="item-h" style="object-fit: contain;" :src="item.barticleUrl" alt="">
							<img class="item-f" src="../../public/imgs/3881735286132_.pic.jpg" alt="">
						</div>
					</div>
					<img class="ry-b-r" @click="prev" style="cursor: pointer;" src="../../public/imgs/home/编组 6@2x(1).png" alt="">
				</div>
				<div class="ry-more" style="cursor: pointer;">
					<div id="morebtn" @click="goabout(2)">查看更多</div>
				</div>
			</div>
		</div>

		<!-- 投资模式 -->
		<div class="tz">
			<div class="tz-cc">
				<div class="tz-h">投资模式</div>
				<div class="tz-b">
					<div class="item">
						<img class="bgimg" src="../assets/home/蒙版@2x.png" alt="">
						<div class="item-t" >
							能源管理模式
						</div>
						<div class="item-s">
							业主出租屋顶或土地，公司投资建设并运营电站，业主享受电费折扣或租金；
						</div>
						<div class="item-b" id="investBtn" style="cursor: pointer; color: white; background-color: #22A3D3;" @click="goservice">
							我要投资
						</div>
					</div>
					<div class="item">
						<img class="bgimg" src="../assets/home/home2.png" alt="">
						<div class="item-t">
							合资共建模式
						</div>
						<div class="item-s">
							由业主或合作方与公司合资设立投资或项目公司，共同投资建设并运营电站，合作方共享收益。
						</div>
						<div class="item-b" id="investBtn" style="cursor: pointer; color: white;  background-color: #22A3D3;" @click="goservice">
							我要投资
						</div>
					</div>
				</div>
			</div>
		</div>
		<footer1></footer1>
		
		
		
		<div v-if="isShowImg" class="preImg">
			<img :src="showImg" alt="" @click="closeViewer"/>
		</div>

		<mobilemenu v-if="isShowMobile" @hiddenMobile="hiddenMobile"></mobilemenu>
	</div>
</template>

<script>
	
	import mobilemenu from "@/components/mobile-menu.vue";
	import hheader1 from "@/components/hheader.vue";
	import footer1 from "@/components/footer.vue";


	import {
		carousellist,
		contentlist,
	} from '@/api/home.js';

	// // 引入Swiper Vue组件
	// import { Swiper, SwiperSlide } from 'swiper/vue';
	// // 引入Swiper样式
	// import 'swiper/swiper-bundle.css';

	import {
		Swiper,
		SwiperSlide
	} from 'swiper/vue';
	import {
		Navigation,
		Pagination,
		A11y,
		Autoplay
	} from 'swiper/modules';
	import 'swiper/css';
	import 'swiper/css/navigation';
	import 'swiper/css/pagination';
	import 'swiper/css/autoplay';



	export default {
		components: {
			hheader1,
			footer1,
			mobilemenu,
			Swiper,
			SwiperSlide,
			
		},
		data() {
			return {
				num1: 0,
				num2: 0,
				
				increment1: 20, // 每次增加的数值
				increment: 50,
				intervalId1: null,
				
				currentStartIndex: 0, // 当前显示图片的起始索引
				imagesPerBatch: 4 ,
					
				isShowImg:false,
				showImg:"",
				
				dialogVisible: false,
				      imageUrl: "https://manage.zgeec.com/prod-api/profile/upload/2025/01/22/19cbba0f-ccac-4567-8615-211e91e6f0a9.jpg", // 你的图片URL
				      isZoomed: false, // 用于控制是否放大图片
				
				modules: [A11y, Autoplay],
				isShowMobile: false,
				pathname: "index",
				images: ["1", "2", "3"],
				list: [],
				locallist:[{
					carouselUrl:"../assets/newimg/102.jpg"
				},
				{
					carouselUrl:"../assets/newimg/103.jpg"
				}],
				xwlist: [],
				rylist: [],
				cIndex: 0,
				total:0,
				screenW:0,
				screenH:0


			}
		},
		created(e) {
			this.getcarousellist()
			this.getxwcontentlist()
			this.getrycontentlist()
			this.getScreenSize()
			
			var that = this
			this.intervalId1 = setInterval(function(){
				
				if(that.num2 < 1000) {
					that.num2 += that.increment1;
				}
				
				if (that.num1 < 5000) {
					that.num1 += that.increment;
				} else {
					clearInterval(that.intervalId1); // 达到目标值后清除定时器
				}
			}, 80);

		},
		beforeDestroy() {
			clearInterval(this.intervalId1); // 清除定时器，避免内存泄漏
			
		},
		computed: {
		    currentImages() {
		      return this.rylist.slice(this.currentStartIndex, this.currentStartIndex + this.imagesPerBatch);
		    }
		  },
		methods: {
			getScreenSize() {
			      const width = window.innerWidth;
			      const height = window.innerHeight;
				  this.screenW = width
				  this.screenH = height+"px"
			      console.log(this.screenH, "this.screenH");
			}, 
			next() {
			      if (this.currentStartIndex + this.imagesPerBatch < this.rylist.length) {
			        this.currentStartIndex += this.imagesPerBatch;
			      } else {
			        // 如果已经到最后一组，可以选择重置或者停止加载更多图片等逻辑
			        this.currentStartIndex = 0; // 重置为第一组
			      }
			    },
			    prev() {
			      if (this.currentStartIndex >= this.imagesPerBatch) {
			        this.currentStartIndex -= this.imagesPerBatch;
			      } else {
			        // 如果已经到第一组，可以选择重置或者停止加载更多图片等逻辑
			        this.currentStartIndex = (Math.floor((this.rylist.length - 1) / this.imagesPerBatch) * this.imagesPerBatch); // 设置为最后一组第一张图片的索引
			      }
			    },
			handlePreview(url) {
				this.showImg = url
			      this.isShowImg = true
			    },
			    // 关闭查看器
			    closeViewer() {
			      this.isShowImg = false
			    },
			onSwiper(e) {

			},
			onSlideChange(e) {

				this.cIndex = e.realIndex
				console.log('Active index:', this.cIndex);
			},

			hiddenMobile() {
				this.isShowMobile = false
			},
			showMobile() {
				this.isShowMobile = true
			},
			getcarousellist() {
				carousellist({
					pageNum: this.pageNum,
					pageSize: 10,
					companyId: 1
				}).then(res => {
					if (res.data.code == 200) {
						this.list = res.data.rows
					}
				})
			},
			getxwcontentlist() {
				contentlist({
					pageNum: this.pageNum,
					pageSize: 3,
					companyId: 1,
					categoryId: 442
				}).then(res => {
					if (res.data.code == 200) {
						this.xwlist = res.data.rows
					}
				})
			},
			getrycontentlist() {
				contentlist({
					pageNum: 1,
					pageSize: 100,
					companyId: 1,
					categoryId: 429
				}).then(res => {
					if (res.data.code == 200) {
						this.rylist = res.data.rows
						this.total = res.data.total
					}
				})
			},
			tapprev() {
				
			},
			tapnext() {
				
			},
			tapMediumDetails(item) {
				this.$router.push({
					path: "/mediumdetails",
					query: {
						id: item.bid
					}
				})
			},
			goMedium() {
				this.$router.push({
					path: "/medium"
				})
			},
			goabout(index) {
				this.$router.push({
					path: "/about",
					query: {
						index: index
					}
				})
			},
			goservice() {
				this.$router.push({
					path: "/service"
				})
			},
			gocase() {
				this.$router.push({
					path: "/case"
				})
			},




		}
	}
</script>

<style lang="scss">
	.content {
		
		.preImg {
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: rgba(0, 0, 0, 0.5);
			z-index: 9999;
			img {
				width: 50%;
				height: 80%;
				object-fit: contain;
			}
		}
		
		.banner {
			position: relative;
			.banner-sec {
				position: absolute;
				top: 0;
				left:0;
				width:100%;
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				div {
					font-family: AlibabaPuHuiTi-Medium;
					font-weight: 500;
					color: #FFFFFF;
					letter-spacing: 0;
					text-align: center;
					// 488CB8
					text-shadow: 0 2px 4px #516c2b;
				}
				
			}
		}


		.gs {
			background-color: #FFFFFF;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;

			background: url('../assets/about/about-bg.png') no-repeat 100% 100%;
			background-size: cover;
			.gs-cc {
				justify-content: space-between;
				
				.gs-c-l {


					.gs-c-l-f {

						justify-content: space-between;
						align-items: center;

						.item {
							flex: 1;
							text-align: center;

							.item-h {
								font-family: BebasNeue-Regular;
								font-weight: 400;
								color: #22A3D3;
								cursor: pointer;

								span {
									color: #22A3D3;
								}
							}

							.item-f {
								font-weight: 400;
								color: #22A3D3;
							}
						}
					}
				}

				.gs-c-r {

					flex-direction: column;
					justify-content: flex-start;

					.title {
						font-weight: 500;
						color: #332C2B;
					}

					.sec {
						font-weight: 400;

						color: #332C2B;
					}

					.more {

						justify-content: center;
						align-items: center;

						div {

							color: #22A3D3;
							text-align: center;

						}
					}
				}
			}
		}

		// 业务与服务
		.fw {
			background-color: #F3F9F9;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			box-sizing: border-box;



			.fw-h {

				text-align: center;
				color: #333;
			}

			.fw-b {

				position: relative;
				justify-content: center;
				align-items: center;
				flex-wrap: wrap;

				.fw-b-sec {
					position: absolute;

					font-family: AlibabaPuHuiTi-Regular;
					font-weight: 400;
					color: #666666;

				}

				.fw-b-sec1 {
					position: absolute;

					font-family: AlibabaPuHuiTi-Regular;
					font-weight: 400;
					color: #666666;

				}

				.fw-b-sec2 {
					position: absolute;

					font-family: AlibabaPuHuiTi-Regular;
					font-weight: 400;
					color: #666666;

				}





			}

			.fw-more {

				justify-content: center;
				align-items: center;

				#morebtn111 {

					color: #22A3D3;
					text-align: center;

				}
				#morebtn111:hover {
				    background-color: #22A3D3;
					color: white;
					
				}
				
			}
		}

		//新闻媒体
		.mt {
			background-color: #FFFFFF;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;



			.mt-h {

				text-align: center;
				color: #333;
			}

			.mt-b {

				justify-content: space-between;
				// align-items: center;
				flex-wrap: wrap;

				.item {
					transition: transform 0.3s;

					.item-t {

						color: #332C2B;
					}

					.item-s {

						color: #999999;
					}
				}
				.item:hover {
				       transition: width 0.3s, height 0.3s;
				       transform: scale(0.95);
				       
				      }


			}

			.mt-more {

				justify-content: center;
				align-items: center;

				div {

					color: #22A3D3;
					text-align: center;

				}
			}
		}

		// 合作伙伴
		.hb {

			background-color: rgba(34, 163, 211, 0.05);
			flex-direction: column;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;



			.hb-h {

				text-align: center;
				color: #333;
			}

			.hb-b {

				justify-content: flex-start;
				align-items: center;
				flex-wrap: wrap;




			}

			.hb-more {

				justify-content: center;
				align-items: center;

				#morebtn11 {

					color: #22A3D3;
					text-align: center;

				}
				#morebtn11:hover {
					background-color: #22A3D3;
					color: white;
				}
			}
		}

		// 资质荣誉
		.ry {
			background-color: #FFFFFF;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;


			.ry-h {

				text-align: center;
				color: #333;
			}

			.ry-b {

				justify-content: space-between;
				align-items: center;



				.ry-b-c {

					justify-content: space-between;
					align-items: center;

					.item {

						flex-direction: column;
						justify-content: center;
						align-items: center;


					}

				}


			}

			.ry-more {
				justify-content: center;
				align-items: center;
				cursor: pointer;

				div {

					color: #22A3D3;
					text-align: center;

				}
			}
		}

		// 投资模式
		.tz {

			background-color: #F3F9F9;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.tz-cc {}

			.tz-h {

				text-align: center;
				color: #333;
			}

			.tz-b {
				display: flex;
				justify-content: space-between;
				align-items: center;

				.item {
					   transition: transform 0.3s;

					box-sizing: border-box;
					position: relative;

					// background-image:url(../../public/imgs/home/蒙版@2x.png);
					.bgimg {
						position: absolute;

						z-index: 0;
					}

					.item-t {
						color: #fff;
						position: relative;
						z-index: 3;
					}

					.item-s {

						color: #FFFFFF;
						position: relative;
						z-index: 3;
					}

					.item-b {
						margin-top: 24px;
						position: relative;
						z-index: 3;
						border: 1px solid #22A3D3;
						text-align: center;
						color: #22A3D3;;

					}
				}
				.item:hover {
				       transition: width 0.3s, height 0.3s;
				       transform: scale(0.95);
				       
				      }

			}
		}
	}

	.swiper-container {

		position: relative;

		.pagination {
			position: absolute;

			z-index: 999;
			display: flex;
			justify-content: center;

			div {

				background: #ffffff4d;
				border-radius: 4px;
				margin: 0 5px;
			}

			.sdiv {
				background: #FFFFFF;
			}
		}
	}

	.swiper-slide {

		.banner {

			position: relative;
			justify-content: center;
			align-items: center;

			img {
				position: absolute;

				z-index: -1;
			}

			div {
				text-align: center;

				color: #FFFFFF;
			}
		}

		object-fit: cover;

		display: block;

	}
	
	#morebtn:hover {
		background-color: #22A3D3;
		color: white;
	}
	#investBtn:hover {
		background-color: #22A3D3;
		color: white;
		border: 0;
	}




	@media screen and (min-width: 1200px) {
		.content {
			// padding-top: 100px;
			.banner{
				.banner-sec {
					top:-20%;
					div {
						// font-size: 28px;
						font-size:35px;
					}
				}
			}

			.gs {
				width: 100%;
				display: flex;
				padding-bottom: 80px;
				padding: 120px 0 60px;

				.gs-cc {
					width: 1200px;
					display: flex;

					.gs-c-l {
						width: 60%;

						img {
							width: 100%;
							height:402px;
						}

						.gs-c-l-f {
							margin-top: 39px;
							display: flex;

							.item {
								flex: 1;
								text-align: center;

								.item-h {
									font-weight: 400;
									font-size: 50px;

									span {
										font-size: 16px;
									}
								}

								.item-f {
									font-weight: 400;
									font-size: 16px;
								}
							}
						}
					}

					.gs-c-r {
						width: calc(40% - 30px);
						display: flex;

						.title {
							font-weight: 500;
							font-size: 30px;
							margin-bottom: 10px;
						}

						.sec {
							&.sec-zh{
								font-size:14px !important;
								line-height:24px !important;
							}
							font-weight: 400;
							font-size: 18px;
							text-indent: 32px;
						}

						.more {
							margin-top: 54px;
							width: 100%;
							display: flex;

							div {
								width: 220px;
								height: 57px;
								border: 1px solid #22A3D3;
								line-height: 57px;
								border-radius: 2px;
							}
						}
					}
				}
			}

			// 业务与服务
			.fw {
				width: 100%;
				display: flex;
				padding-bottom: 80px;

				.fw-cc {
					width: 1200px;
				}

				.fw-h {
					height: 180px;
					line-height: 180px;
					font-size: 32px;
				}

				.fw-b {
					width: 100%;
					display: flex;

					img {
						width: 80%;
						// height:544px;
						margin-top: 40px;
						margin-bottom: 20px;
					}

					.fw-b-sec {
						top: 50px;
						left: calc(50% + 100px);
						width: 360px;
						font-size: 16px;

					}

					.fw-b-sec1 {
						top: 460px;
						left: calc(50% - 550px);
						width: 360px;
						font-size: 16px;
					}

					.fw-b-sec2 {
						top: 460px;
						left: calc(50% + 240px);
						width: 360px;
						font-size: 16px;

					}

				}

				.fw-more {
					width: 100%;
					display: flex;

					div {
						width: 220px;
						height: 57px;
						border: 1px solid #22A3D3;
						line-height: 57px;
						border-radius: 2px;
					}
				}
			}

			//新闻媒体
			.mt {
				width: 100%;
				display: flex;
				padding-bottom: 80px;

				.mt-cc {
					width: 1200px;
				}

				.mt-h {
					height: 180px;
					line-height: 180px;
					font-size: 32px;
				}

				.mt-b {
					width: 100%;
					display: flex;
					justify-content: space-between;

					.item {
						width: calc(33.33% - 10px);

						img {
							width: 100%;
							height: 320px;
						}

						.item-t {
							margin-top: 25px;
							font-size: 26px;
						}

						.item-s {
							margin-top: 16px;
							font-size: 16px;
						}
					}

				}

				.mt-more {
					width: 100%;
					display: flex;

					div {
						width: 220px;
						height: 57px;
						border: 1px solid #22A3D3;
						line-height: 57px;
						border-radius: 2px;
					}
				}
			}

			// 合作伙伴
			.hb {
				width: 100%;
				display: flex;
				padding-bottom: 80px;

				.hb-cc {
					width: 1200px;
				}

				.hb-h {
					height: 180px;
					line-height: 180px;
					font-size: 32px;
				}

				.hb-b {
					width: 100%;
					display: flex;

					img {
						width: 16.6%;
						height: 8%;
						// height: 120px;
					}

				}

				.hb-more {
					width: 100%;
					display: flex;

					#morebtn11 {
						width: 220px;
						height: 57px;
						border: 1px solid #22A3D3;
						line-height: 57px;
						border-radius: 2px;
					}
				}
			}

			// 资质荣誉
			.ry {
				width: 100%;
				display: flex;
				padding-bottom: 80px;

				.ry-cc {
					width: 1200px;
					min-width: 1200px;
				}

				.ry-h {
					height: 180px;
					line-height: 180px;
					font-size: 32px;
				}

				.ry-b {
					width: 100%;
					display: flex;

					.ry-b-l,
					.ry-b-r {
						width: 55px;
						height: 55px;
						
					}

					.ry-b-c {
						width: calc(100% - 200px);
						display: flex;

						.item {
							width: calc(25% - 30px);
							display: flex;

							.item-h {
								width: 100%;
								height: 220px;
							}

							.item-f {
								width: 100%;
								height: 108px;
							}
						}

					}


				}

				.ry-more {
					width: 100%;
					display: flex;

					#morebtn {
						width: 220px;
						height: 57px;
						border: 1px solid #22A3D3;
						line-height: 57px;
						border-radius: 2px;
					}
					
				}
			}

			// 投资模式
			.tz {

				width: 100%;
				display: flex;
				padding-bottom: 80px;



				.tz-h {
					height: 180px;
					line-height: 180px;
					font-size: 32px;
				}

				.tz-b {
					width: 1200px;
					display: flex;

					.item {
						width: calc(50% - 20px);
						height: 500px;
						padding: 40px;

						.bgimg {
							top: 0;
							left: 0;
							width: 100%;
							height: 500px;
						}

						.item-t {
							font-size: 32px;
						}

						.item-s {
							width: 400px;
							margin-top: 15px;
							font-size: 18px;
						}

						.item-b {
							margin-top: 24px;
							width: 220px;
							height: 55px;
							
							line-height: 55px;
							border-radius: 2px;
						}
					}
				}
			}
		}

		.swiper-container {
			width: 100%;
			// height: 650px;
			height: 100vh !important;

			.pagination {
				bottom: 30px;
				left: calc(50% - 150px);
				width: 300px;
				height: 20px;

				div {
					width: 24px;
					height: 7px;

					margin: 0 5px;
				}

			}
		}

		.swiper-slide {
			width: 100%;
			// height: 650px;
			img {
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}

			.banner {
				width: 100%;
				// height: 650px;
				display: flex;
				height: 100vh !important;

				img {
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
				}

				div {
					width: 100%;
					font-size: 48px;
				}
			}
		}

		.swiper-pagination-bullet {
			width: 20px;
			height: 20px;
		}


	}

	@media screen and (max-width: 1200px) {
		.content {
			// padding-top: 80px;
			.banner{
				.banner-sec {
					
					div {
						font-size: 22px;
					}
				}
			}

			.gs {
				width: 100%;
				display: flex;
				padding-bottom: 80px;
				padding: 60px 20px 40px;

				.gs-cc {
					width: 100%;
					display: flex;

					.gs-c-l {
						width: 60%;

						img {
							width: 100%;
						}

						.gs-c-l-f {
							margin-top: 24px;
							display: flex;

							.item {
								flex: 1;
								text-align: center;

								.item-h {
									font-weight: 400;
									font-size: 30px;

									span {
										font-size: 15px;
									}
								}

								.item-f {
									font-weight: 400;
									font-size: 15px;
								}
							}
						}
					}

					.gs-c-r {
						width: calc(40% - 20px);
						display: flex;

						.title {
							font-weight: 500;
							font-size: 24px;
							margin-bottom: 8px;
						}

						.sec {
							font-weight: 400;
							font-size: 15px;
							text-indent: 30px;
						}

						.more {
							margin-top: 30px;
							width: 100%;
							display: flex;

							div {
								width: 180px;
								height: 48px;
								border: 1px solid #22A3D3;
								line-height: 48px;
								border-radius: 2px;
							}
						}
					}
				}
			}

			// 业务与服务
			.fw {
				width: 100%;
				display: flex;
				padding-bottom: 60px;

				.fw-cc {
					width: 100%;
				}

				.fw-h {
					height: 120px;
					line-height: 120px;
					font-size: 24px;
				}

				.fw-b {
					width: 100%;
					display: flex;

					img {
						width: 80%;
						// height:544px;
						margin-top: 30px;
						margin-bottom: 16px;
					}

					.fw-b-sec {
						top: 45px;
						left: calc(50% + 80px);
						width: 320px;
						font-size: 14px;

					}

					.fw-b-sec1 {
						top: 360px;
						left: calc(50% - 400px);
						width: 320px;
						font-size: 14px;
					}

					.fw-b-sec2 {
						top: 360px;
						left: calc(50% + 180px);
						width: 320px;
						font-size: 14px;

					}

				}

				.fw-more {
					width: 100%;
					display: flex;

					div {
						width: 140px;
						height: 45px;
						border: 1px solid #22A3D3;
						line-height: 45px;
						border-radius: 2px;
					}
				}
			}

			//新闻媒体
			.mt {
				width: 100%;
				display: flex;
				padding: 0 20px 60px;

				.mt-cc {
					width: 100%;
				}

				.mt-h {
					height: 120px;
					line-height: 120px;
					font-size: 24px;
				}

				.mt-b {
					width: 100%;
					display: flex;
					justify-content: space-between;

					.item {
						width: calc(33.33% - 10px);

						img {
							width: 100%;
							height: 260px;
						}

						.item-t {
							margin-top: 20px;
							font-size: 18px;
						}

						.item-s {
							margin-top: 12px;
							font-size: 15px;
						}
					}

				}

				.mt-more {
					width: 100%;
					display: flex;

					div {
						width: 180px;
						height: 45px;
						border: 1px solid #22A3D3;
						line-height: 45px;
						border-radius: 2px;
					}
				}
			}

			// 合作伙伴
			.hb {
				width: 100%;
				display: flex;
				padding-bottom: 60px;


				.hb-cc {
					width: 100%;
				}

				.hb-h {
					height: 140px;
					line-height: 140px;
					font-size: 24px;
				}

				.hb-b {
					width: 100%;
					display: flex;
					padding: 0 20px;

					img {
						width: 33.33%;
						height: 16%;
						// height: 120px;
					}


				}

				.hb-more {
					width: 100%;
					display: flex;

					#morebtn11 {
						width: 180px;
						height: 45px;
						border: 1px solid #22A3D3;
						line-height: 45px;
						border-radius: 2px;
					}
				}
			}

			// 资质荣誉
			.ry {
				width: 100%;
				display: flex;
				padding-bottom: 60px;

				.ry-cc {
					width: 100%;
				}

				.ry-h {
					height: 140px;
					line-height: 140px;
					font-size: 24px;
				}

				.ry-b {
					width: 100%;
					display: flex;

					.ry-b-l,
					.ry-b-r {
						width: 40px;
						height: 40px;
					}

					.ry-b-c {
						width: calc(100% - 160px);
						display: flex;

						.item {
							width: calc(25% - 30px);
							display: flex;

							.item-h {
								width: 100%;;
								height: 180px;
							}

							.item-f {
								width: 100%;;
								height: 80px;
							}
						}

					}


				}

				.ry-more {
					width: 100%;
					display: flex;

					div {
						width: 180px;
						height: 45px;
						border: 1px solid #22A3D3;
						line-height: 45px;
						border-radius: 2px;
					}
				}
			}

			// 投资模式
			.tz {

				width: 100%;
				display: flex;
				padding-bottom: 60px;



				.tz-h {
					height: 140px;
					line-height: 140px;
					font-size: 32px;
				}

				.tz-b {
					width: 100%;
					display: flex;
					padding: 0 20px;

					.item {
						width: calc(50% - 15px);
						height: 400px;
						padding: 30px;

						.bgimg {
							top: 0;
							left: 0;
							width: 100%;
							height: 400px;
						}

						.item-t {
							font-size: 24px;
						}

						.item-s {
							width: 100%;
							margin-top: 12px;
							font-size: 15px;
						}

						.item-b {
							margin-top: 24px;
							width: 180px;
							height: 45px;
							line-height: 45px;
							border-radius: 2px;
						}
					}
				}
			}
		}

		.swiper-container {
			width: 100%;
			// height: 450px;
			height: auto;

			.pagination {
				bottom: 10px;
				left: calc(50% - 150px);
				width: 300px;
				height: 20px;

				div {
					width: 18px;
					height: 5px;

					margin: 0 4px;
				}

			}
		}

		.swiper-slide {
			width: 100%;
			// height: 850px;

			.banner {
				width: 100%;
				height: 450px;
				display: flex;

				img {
					top: 0;
					left: 0;
					width: 100%;
					height: 450px;
				}

				div {
					width: 100%;
					font-size: 28px;
				}
			}
		}

		.swiper-pagination-bullet {
			width: 20px;
			height: 20px;
		}

	}

	@media screen and (max-width: 880px) {
		.content {
			padding-top: 50px;
			.banner{
				.banner-sec {
					padding: 0 10px;
					div {
						font-size: 14px;
					}
				}
			}

			.gs {
				width: 100%;
				display: flex;
				padding-bottom: 40px;
				padding: 30px 12px 20px;

				.gs-cc {
					width: 100%;
					display: flex;
					flex-direction: column;

					.gs-c-l {
						width: 100%;

						img {
							width: 100%;
						}

						.gs-c-l-f {
							margin-top: 16px;
							display: flex;

							.item {
								flex: 1;
								text-align: center;

								.item-h {
									font-weight: 400;
									font-size: 15px;

									span {
										font-size: 14px;
									}
								}

								.item-f {
									font-weight: 400;
									font-size: 14px;
								}
							}
						}
					}

					.gs-c-r {
						margin-top: 15px;
						width: 100%;
						display: flex;

						.title {
							font-weight: 500;
							font-size: 18px;
							margin-bottom: 5px;
						}

						.sec {
							font-weight: 400;
							font-size: 14px;
							text-indent: 28px;
						}

						.more {
							margin-top: 20px;
							width: 100%;
							display: flex;

							div {
								width: 120px;
								height: 45px;
								border: 1px solid #22A3D3;
								line-height: 45px;
								border-radius: 2px;
							}
						}
					}
				}
			}

			// 业务与服务
			.fw {
				width: 100%;
				display: flex;
				padding-bottom: 40px;

				.fw-cc {
					width: 100%;
				}

				.fw-h {
					height: 90px;
					line-height: 90px;
					font-size: 20px;
				}

				.fw-b {
					width: 100%;
					display: flex;

					img {
						width: 80%;
						// height:544px;
						margin-top: 20px;
						margin-bottom: 14px;
					}

					.fw-b-sec {
						top: 30px;
						left: calc(50% + 50px);
						width: 160px;
						font-size: 12px;

					}

					.fw-b-sec1 {
						top: 200px;
						left: calc(50% - 400px);
						width: 160px;
						font-size: 12px;
					}

					.fw-b-sec2 {
						top: 360px;
						left: calc(50% + 180px);
						width: 160px;
						font-size: 12px;

					}

				}

				.fw-more {
					width: 100%;
					display: flex;

					div {
						width: 120px;
						height: 45px;
						border: 1px solid #22A3D3;
						line-height: 45px;
						border-radius: 2px;
					}
				}
			}

			//新闻媒体
			.mt {
				width: 100%;
				display: flex;
				padding: 0 20px 40px;

				.mt-cc {
					width: 100%;
				}

				.mt-h {
					height: 90px;
					line-height: 90px;
					font-size: 20px;
				}

				.mt-b {
					width: 100%;
					display: flex;
					justify-content: space-between;

					.item {
						width: calc(33.33% - 10px);

						img {
							width: 100%;
							height: 120px;
						}

						.item-t {
							margin-top: 12px;
							font-size: 14px;
						}

						.item-s {
							margin-top: 12px;
							font-size: 12px;
						}
					}

				}

				.mt-more {
					width: 100%;
					display: flex;

					div {
						width: 120px;
						height: 45px;
						border: 1px solid #22A3D3;
						line-height: 45px;
						border-radius: 2px;
					}
				}
			}

			// 合作伙伴
			.hb {
				width: 100%;
				display: flex;
				padding-bottom: 40px;


				.hb-cc {
					width: 100%;
				}

				.hb-h {
					height: 90px;
					line-height: 90px;
					font-size: 20px;
				}

				.hb-b {
					width: 100%;
					display: flex;
					padding: 0 12px;

					img {
						width: 33.33%;
						height: 16%;
						// height: 120px;
					}


				}

				.hb-more {
					width: 100%;
					display: flex;

					#morebtn11 {
						width: 180px;
						height: 45px;
						border: 1px solid #22A3D3;
						line-height: 45px;
						border-radius: 2px;
					}
				}
			}

			// 资质荣誉
			.ry {
				width: 100%;
				display: flex;
				padding-bottom: 40px;

				.ry-cc {
					width: 100%;
				}

				.ry-h {
					height: 100px;
					line-height: 100px;
					font-size: 20px;
				}

				.ry-b {
					width: 100%;
					display: flex;
					justify-content: space-between;

					.ry-b-l,
					.ry-b-r {
						display: none;
						width: 20px;
						height: 20px;
					}

					.ry-b-c {
						width: 100%;
						display: flex;
						flex-wrap: wrap;

						.item {
							width: calc(50% - 12px);
							display: flex;

							.item-h {
								width: 100%;
								height: 140px;
							}

							.item-f {
								width: 100%;
								height: 60px;
							}
						}

					}


				}

				.ry-more {
					width: 100%;
					display: flex;

					div {
						width: 160px;
						height: 45px;
						border: 1px solid #22A3D3;
						line-height: 45px;
						border-radius: 2px;
					}
				}
			}

			// 投资模式
			.tz {

				width: 100%;
				display: flex;
				padding-bottom: 40px;



				.tz-h {
					height: 100px;
					line-height: 100px;
					font-size: 20px;
				}

				.tz-b {
					width: 100%;
					display: flex;
					padding: 0 20px;
					flex-wrap: wrap;

					.item {
						width: 100%;
						height: 300px;
						padding: 20px;
						margin-bottom: 12px;

						.bgimg {
							top: 0;
							left: 0;
							width: 100%;
							height: 300px;
						}

						.item-t {
							font-size: 18px;
						}

						.item-s {
							width: 100%;
							margin-top: 12px;
							font-size: 15px;
						}

						.item-b {
							margin-top: 24px;
							width: 160px;
							height: 45px;
							line-height: 45px;
							border-radius: 2px;
						}
					}
				}
			}
		}

		.swiper-container {
			width: 100%;
			height: 380px !important;
			// height: auto;

			.pagination {
				bottom: 0px;
				left: calc(50% - 150px);
				width: 300px;
				height: 20px;

				div {
					width: 12px;
					height: 4px;

					margin: 0 2px;
				}

			}

			img {
				width: 100%;
				height: 380px;
			}
		}

		.swiper-slide {
			width: 100%;
			height: 380px !important;

			.banner {
				width: 100%;
				height: 380px;
				display: flex;

				img {
					top: 0;
					left: 0;
					width: 100%;
					height: 380px;
				}

				div {
					width: 100%;
					font-size: 28px;
				}
			}
		}

		.swiper-pagination-bullet {
			width: 20px;
			height: 20px;
		}

	}
</style>